import { render, staticRenderFns } from "./Atest.vue?vue&type=template&id=e619cd24&scoped=true"
import script from "./Atest.vue?vue&type=script&lang=js"
export * from "./Atest.vue?vue&type=script&lang=js"
import style0 from "./Atest.vue?vue&type=style&index=0&id=e619cd24&prod&lang=scss&scoped=true"
import style1 from "./Atest.vue?vue&type=style&index=1&id=e619cd24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e619cd24",
  null
  
)

export default component.exports